// generated by genversion
export var version = '3.2.2';
//# sourceMappingURL=version.js.map